import { Button, ButtonPassThroughOptions } from 'primeng/button';

import { getColor, getFontWeight, getRem } from '../theme-utils';

export const FilterButtonPT: ButtonPassThroughOptions = {
  root: (options) => {
    const button = options.instance as Button;

    return {
      style: {
        gap: getRem(6),
        color: button.disabled ? '' : getColor('SeaBlue'),
        background: 'transparent',
        border: 'transparent',
        opacity: button.disabled ? 0.8 : 1,
        height: getRem(40),
      },
    };
  },
  label: {
    style: {
      fontWeight: getFontWeight('bold'),
    },
  },
  icon: {
    style: {
      fontSize: getRem(12),
    },
  },
};
